/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '../fetch-graphql';
import { GET_ATTRIBUTES_FORM } from './graphql/getAttributesForm.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { transformAttributesForm } from '@/auth/data/transforms';
import { handleFetchError } from '@/auth/lib/fetch-error';
import { AttributesFormModel } from '@/auth/data/models';
import { GetAttributesFormResponse } from '@/auth/types';

export const getAttributesForm = async (
  formCode: string
): Promise<AttributesFormModel[]> => {
  return await fetchGraphQl(GET_ATTRIBUTES_FORM, {
    method: 'GET',
    cache: 'force-cache',
    variables: { formCode },
  })
    .then((response: GetAttributesFormResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return transformAttributesForm(response);
    })
    .catch(handleNetworkError);
};
